export default __webpack_public_path__ + "static/media/ibrahiShamsi1.37804336.png";